import { InterfaceMonitoringSearchCriteria } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringSearchCriteria";
import { BankInterfaceMonitoringMaintenanceConstant } from "presentation/constant/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceConstant";
import { useBankInterfaceMonitoringMaintenanceVM } from "presentation/hook/BankInterfaceMonitoring/useBankInterfaceMonitoringMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useBankInterfaceMonitoringMaintenanceTracked } from "presentation/store/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

export const BankInterfaceMonitoringMainSearchPanel = () => {
    const [bankInterfaceMonitoringState] = useBankInterfaceMonitoringMaintenanceTracked();
    const bankInterfaceMonitoringVM = useBankInterfaceMonitoringMaintenanceVM();
    const SCREEN_CONSTANT = BankInterfaceMonitoringMaintenanceConstant;
    const { searchCriteria, isShowRightPanel } = bankInterfaceMonitoringState;
    const messageBarVM = useMessageBarVM();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const resetButtonClicked = useCallback(() => {
        bankInterfaceMonitoringVM.onRemoveAllSearchCriteria();
    }, [bankInterfaceMonitoringVM]);

    const searchButtonClicked = useCallback((searchCriteria: InterfaceMonitoringSearchCriteria) => {
        if (!searchCriteria.dateFrom && !searchCriteria.dateTo) {
            messageBarVM.showError("Must input Date (From) and Date (To) in search criteria.");
            return;
        }
        setIsLoading(true);
        bankInterfaceMonitoringVM.setIsSearchLoading(true);
        bankInterfaceMonitoringVM.onSearch(searchCriteria).then((data) => {
            setIsLoading(false);
            bankInterfaceMonitoringVM.setIsSearchLoading(false);
        }).catch(error => {
            setIsLoading(false);
            bankInterfaceMonitoringVM.setIsSearchLoading(false);
        })

    }, [bankInterfaceMonitoringVM, messageBarVM])

    const memoMessageType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.messageType || ''}
                fieldValue={searchCriteria?.messageType}
                fieldLabel={SCREEN_CONSTANT.MESSAGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'messageType'}
                options={bankInterfaceMonitoringState.dynamicOptions.messageTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankInterfaceMonitoringVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.messageType, SCREEN_CONSTANT.MESSAGE_TYPE, bankInterfaceMonitoringState.dynamicOptions.messageTypeDropdownOptions, bankInterfaceMonitoringVM])

    const memoFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.from || ''}
                fieldValue={searchCriteria?.from}
                fieldLabel={SCREEN_CONSTANT.FROM}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'from'}
                options={bankInterfaceMonitoringState.dynamicOptions.formDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankInterfaceMonitoringVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.from, SCREEN_CONSTANT.FROM, bankInterfaceMonitoringState.dynamicOptions.formDropdownOptions, bankInterfaceMonitoringVM])

    const memoTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.to || ''}
                fieldValue={searchCriteria?.to}
                fieldLabel={SCREEN_CONSTANT.TO}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'to'}
                options={bankInterfaceMonitoringState.dynamicOptions.toDropdownOptions}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankInterfaceMonitoringVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.to, SCREEN_CONSTANT.TO, bankInterfaceMonitoringState.dynamicOptions.toDropdownOptions, bankInterfaceMonitoringVM])

    const memoDateFromTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "470px", marginBottom: "24px" }}>
            <DateRangePickerComponent
                label={SCREEN_CONSTANT.DATE_RANGE}
                width='470px'
                fieldNames={{ startField: "dateFrom", endField: "dateTo" }}
                dateRange={{ startDate: searchCriteria.dateFrom, endDate: searchCriteria.dateTo }}
                onDatesChange={bankInterfaceMonitoringVM.onDateRangeChange}
            />
        </div>
        , [SCREEN_CONSTANT.DATE_RANGE, bankInterfaceMonitoringVM.onDateRangeChange, searchCriteria.dateFrom, searchCriteria.dateTo])

    // const memoDateFrom = useMemo(() =>
    //     <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
    //         <DatePickerComponent
    //             disabled={false}
    //             optional={false}
    //             label={SCREEN_CONSTANT.DATE_FROM}
    //             width="220px"
    //             date={searchCriteria?.dateFrom}
    //             fieldName="dateFrom"
    //             errorMessage={""}
    //             onDateChange={bankInterfaceMonitoringVM.onSearchFieldChange} />
    //     </div>
    //     , [SCREEN_CONSTANT.DATE_FROM, bankInterfaceMonitoringVM.onSearchFieldChange, searchCriteria?.dateFrom])

    // const memoDateTo = useMemo(() =>
    //     <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
    //         <DatePickerComponent
    //             disabled={false}
    //             optional={false}
    //             label={SCREEN_CONSTANT.DATE_TO}
    //             width="220px"
    //             date={searchCriteria?.dateTo}
    //             fieldName="dateTo"
    //             errorMessage={""}
    //             onDateChange={bankInterfaceMonitoringVM.onSearchFieldChange} />
    //     </div>
    //     , [SCREEN_CONSTANT.DATE_TO, bankInterfaceMonitoringVM.onSearchFieldChange, searchCriteria?.dateTo])

    const memoStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.status || ''}
                fieldValue={searchCriteria?.status}
                fieldLabel={SCREEN_CONSTANT.STATUS}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'status'}
                options={bankInterfaceMonitoringState.dynamicOptions.statusDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankInterfaceMonitoringVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.status, SCREEN_CONSTANT.STATUS, bankInterfaceMonitoringState.dynamicOptions.statusDropdownOptions, bankInterfaceMonitoringVM])

    return (
        <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{SCREEN_CONSTANT.SEARCH_CRITERIA}</SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={bankInterfaceMonitoringVM.onSearchClick} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        {/* Stack Form Start */}
                        <CriteriaItemContainer>
                            {memoMessageType}
                            {memoStatus}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoFrom}
                            {memoTo}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoDateFromTo}
                        </CriteriaItemContainer>
                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={resetButtonClicked} />
                <HPHButton label={'Search'} size={'Small'} theme={'Primary'} disabled={isShowRightPanel} onClick={() => searchButtonClicked(searchCriteria)} />
            </SidebarActionBar>
        </div>
    )
}
